import { render, staticRenderFns } from "./ChargeWallet.vue?vue&type=template&id=f3253d86&"
import script from "./ChargeWallet.vue?vue&type=script&lang=ts&"
export * from "./ChargeWallet.vue?vue&type=script&lang=ts&"
import style0 from "./ChargeWallet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports